import { extendTheme } from '@chakra-ui/react';
import {
  BG_SECONDARY,
  BG_PRIMARY,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  BUTTON_COLOR_TEXT,
  BG_PRIMARY_GRADIENT,
  QR_BORDER_COLOR,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '48px',
    subHeading: '20px',
    body: '16px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
      },
    },
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgPrimaryGradient: BG_PRIMARY_GRADIENT,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    btnMainColor: BUTTON_COLOR_TEXT,
    borderColorQR: QR_BORDER_COLOR,
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
  },
};

export default extendTheme(theme);
